import React, { useState } from 'react';
import { DynamicIcon } from '../components/icons/DynamicIcon';
import TabDetalhesEvento from '../components/calcbar/TabDetalhesEvento';
import TabConsumoEstimado from '../components/calcbar/TabConsumoEstimado';
import TabSelecaoDrinks from '../components/calcbar/TabSelecaoDrinks';
import TabComplementos from '../components/calcbar/TabComplementos';
import TabSistemaCotacao from '../components/calcbar/TabSistemaCotacao';
import TabOrcamentoFinal from '../components/calcbar/TabOrcamentoFinal';
import TabPersonalizacao from '../components/calcbar/TabPersonalizacao';

export default function EventPour() {
  const [activeTab, setActiveTab] = useState(0);
  const [eventoData, setEventoData] = useState({
    nomeEvento: '',
    tipoEvento: 'aniversario',
    dataEvento: '',
    horarioInicio: '',
    horarioTermino: '',
    localEvento: '',
    numeroConvidados: 50,
    nivelConsumo: 'medio',
    bartenders: 1,
    assistentes: 0,
    margemLucro: 150,
    drinksEscolhidos: [],
    complementos: {
      acucar: true,
      adocante: false,
      gelo: true,
      canudo: true,
      tipoCopos: 'plastico',
      balcao: false
    },
    tema: {
      nome: 'lendario',
      cores: {
        primaria: '#BEB484',
        secundaria: '#BEB484',
        fundo: '#161616',
        superficie: '#242424',
        textoPrincipal: '#FFFFFF',
        textoSecundario: '#B8B8B8'
      }
    }
  });

  const tabs = [
    { icon: "calendar", label: 'Detalhes do Evento' },
    { icon: "glasses", label: 'Consumo e Drinks' },
    { icon: "package", label: 'Equipe e Complementos' },
    { icon: "dollarSign", label: 'Cotação' },
    { icon: "palette", label: 'Personalização' },
    { icon: "fileText", label: 'Orçamento Final' }
  ];

  const goToNextTab = () => {
    if (activeTab < tabs.length - 1) {
      setActiveTab(activeTab + 1);
    }
  };

  const goToPreviousTab = () => {
    if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-purple-700 text-white p-4">
        <h1 className="text-2xl font-bold">EventPour</h1>
        <p className="text-purple-200">Calculadora de Orçamentos para Eventos</p>
      </div>

      {/* Progress Bar */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex overflow-x-auto">
            {tabs.map((tab, index) => (
              <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`flex items-center gap-2 px-4 py-3 whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === index 
                    ? 'border-purple-600 text-purple-600' 
                    : index < activeTab
                      ? 'border-green-500 text-green-600'
                      : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                {index < activeTab ? (
                  <DynamicIcon name="check" size={20} className="text-green-500" />
                ) : (
                  <DynamicIcon name={tab.icon} size={20} />
                )}
                <span className="text-sm font-medium">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="max-w-4xl mx-auto p-4">
        {activeTab === 0 && (
          <TabDetalhesEvento 
            eventoData={eventoData} 
            setEventoData={setEventoData} 
          />
        )}
        
        {activeTab === 1 && (
          <>
            <TabConsumoEstimado 
              eventoData={eventoData} 
              setEventoData={setEventoData} 
            />
            <div className="mt-6">
              <TabSelecaoDrinks 
                eventoData={eventoData} 
                setEventoData={setEventoData} 
              />
            </div>
          </>
        )}
        
        {activeTab === 2 && (
          <TabComplementos 
            eventoData={eventoData} 
            setEventoData={setEventoData} 
          />
        )}
        
        {activeTab === 3 && (
          <TabSistemaCotacao 
            eventoData={eventoData} 
            setEventoData={setEventoData} 
          />
        )}
        
        {activeTab === 4 && (
          <TabPersonalizacao 
            eventoData={eventoData} 
            setEventoData={setEventoData}
          />
        )}
        
        {activeTab === 5 && (
          <TabOrcamentoFinal 
            eventoData={eventoData}
          />
        )}
        
        {/* Navigation Buttons */}
        <div className="flex justify-between mt-6">
          <button
            onClick={goToPreviousTab}
            disabled={activeTab === 0}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
          >
            <DynamicIcon name="arrowLeft" size={16} className="mr-2" />
            Anterior
          </button>
          
          {activeTab < tabs.length - 1 && (
            <button
              onClick={goToNextTab}
              className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 flex items-center"
            >
              Próximo
              <DynamicIcon name="arrowRight" size={16} className="ml-2" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}